export function getGrommet2StepNums({ t, step3A0, step3A, step3B }) {
  let wallSillStepNum2;
  let floorStepNum2;
  let standardCeilingSillStepNum2;
  let standardCeilingFloorStepNum2;
  let wallFloorStepNum2;
  let wallExtensionStepNum2;

  if (step3A === "Wall to Wall") {
    wallSillStepNum2 = t("3D");
  } else if (
    step3A0 === "Wall" &&
    step3A !== "Wall to Wall" &&
    (step3B === "Sill" || step3B === "Apron")
  ) {
    wallSillStepNum2 = t("3E");
  } else {
    wallSillStepNum2 = t("3F");
  }

  if (step3A === "Wall to Wall") {
    floorStepNum2 = t("3D");
  } else {
    floorStepNum2 = t("3E");
  }

  if (step3A === "Wall to Wall") {
    standardCeilingSillStepNum2 = t("3D");
  } else {
    standardCeilingSillStepNum2 = t("3E");
  }

  if (step3A === "Wall to Wall") {
    standardCeilingFloorStepNum2 = t("3D");
  } else {
    standardCeilingFloorStepNum2 = t("3E");
  }

  if (step3A === "Wall to Wall") {
    wallFloorStepNum2 = t("3E");
  } else {
    wallFloorStepNum2 = t("3F");
  }

  if (step3A0 !== "Wall") {
    if (step3A === "Wall to Wall") {
      wallExtensionStepNum2 = t("3E");
    } else {
      wallExtensionStepNum2 = t("3F");
    }
  } else if (step3A === "Wall to Wall") {
    wallExtensionStepNum2 = t("3F");
  } else if (step3A0 === "Wall" && step3A !== "Wall to Wall") {
    if (step3A === "Wall to Wall") {
      wallExtensionStepNum2 = t("3F");
    } else {
      wallExtensionStepNum2 = t("3G");
    }
  } else {
    wallExtensionStepNum2 = t("3H");
  }

  return {
    wallSillStepNum2,
    floorStepNum2,
    standardCeilingSillStepNum2,
    standardCeilingFloorStepNum2,
    wallFloorStepNum2,
    wallExtensionStepNum2,
  };
}
